import { render, staticRenderFns } from "./cooperation-visa-detail.vue?vue&type=template&id=346126a8&scoped=true&"
import script from "./cooperation-visa-detail.vue?vue&type=script&lang=js&"
export * from "./cooperation-visa-detail.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-visa-detail.vue?vue&type=style&index=0&id=346126a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346126a8",
  null
  
)

export default component.exports